<template>
  <v-container>
    <v-dialog v-model="addFileDialog" max-width="500px" persistent>
      <v-card>
        <pi-progress v-if="progress"></pi-progress>
        <v-card-title class="headline">Wysyłanie plików</v-card-title>
        <v-card-text>
          <v-form ref="fileForm" lazy-validation>
            <v-text-field
              v-model="changeData.text"
              :rules="Rules.fileTreeChange.text"
              :disabled="progress"
              required
              name="text"
              label="Opis zmian"
            ></v-text-field>
          </v-form>
          <v-list two-line subheader>
            <v-list-tile v-if="filesData.length < 1">
              <v-list-tile-content>Brak plików</v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(file, index) in filesData"
              :key="file.name"
              avatar
            >
              <v-list-tile-avatar>
                <v-icon class="secondary white--text">insert_drive_file</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title
                  :class="file.size > 524288000 ? 'red--text' : ''"
                  >{{ file.name }}</v-list-tile-title
                >
                <v-list-tile-sub-title
                  v-if="!filesInfo[index].uploaded && filesInfo[index].progress"
                >
                  <v-progress-linear
                    v-model="filesInfo[index].upload"
                  ></v-progress-linear>
                </v-list-tile-sub-title>
                <v-list-tile-sub-title
                  v-if="filesInfo[index].uploaded && !filesInfo[index].status"
                  class="error--text"
                  >{{ filesInfo[index].message }}</v-list-tile-sub-title
                >
                <v-list-tile-sub-title
                  v-if="filesInfo[index].uploaded && filesInfo[index].status"
                  class="success--text"
                  >Przesłane</v-list-tile-sub-title
                >
                <v-list-tile-sub-title
                  v-if="
                    !filesInfo[index].uploaded && !filesInfo[index].progress
                  "
                  >{{ file.size | humanSize }}</v-list-tile-sub-title
                >
              </v-list-tile-content>

              <v-list-tile-action v-if="!filesInfo[index].uploaded">
                <v-btn :disabled="progress" icon @click="deleteFileData(file)">
                  <v-icon color="grey">delete</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-btn flat text block class="file">
            Przeciągnij lub kliknij aby dodać
            <input id="fileinput" type="file" multiple @change="addFileData" />
          </v-btn>
          <v-switch
            v-if="Auth.userData.superadmin"
            :disabled="progress"
            color="accent"
            v-model="incognitoData.active"
            name="incognito"
            label="Incognito"
          ></v-switch>
          <v-menu
            v-if="Auth.userData.superadmin && incognitoData.active"
            v-model="modalDate"
            lazy
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="incognitoData.date"
                :rules="Rules.date.date"
                required
                prepend-icon="event"
                name="date"
                label="Data"
                v-on="on"
                :disabled="progress"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="pl-pl"
              first-day-of-week="1"
              v-model="incognitoData.date"
              no-title
              scrollable
              @input="incognitoData.modalDate = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            v-if="Auth.userData.superadmin && incognitoData.active"
            v-model="modalTime"
            min-width="290px"
            lazy
            ref="menuTime"
            :return-value.sync="incognitoData.time"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="incognitoData.time"
                :rules="Rules.date.date"
                required
                prepend-icon="access_time"
                name="time"
                label="Czas"
                v-on="on"
                :disabled="progress"
              ></v-text-field>
            </template>
            <v-time-picker
              locale="pl-pl"
              v-model="incognitoData.time"
              scrollable
              format="24hr"
              use-seconds
              @click:second="$refs.menuTime.save(incognitoData.time)"
            ></v-time-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            flat
            :disabled="progress"
            @click="rejectChange()"
            >Odrzuć</v-btn
          >
          <v-btn color="info" flat :disabled="progress" @click="addFiles()">{{
            incomplete ? "Wyślij ponownie" : "Wyślij"
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pi-snackbar
      :color="snackbarColor"
      :snackbar.sync="snackbar"
      :message="snackMessage"
    ></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["addFileDialog", "id"],
  data: () => ({
    progress: false,
    snackbar: false,
    snackbarColor: "error",
    snackMessage: "",
    changeData: { text: "", parentId: 0, id: 0 },
    filesData: [],
    filesInfo: [],
    incomplete: false,
    offset: 0,
    incognitoData: {
      active: false,
      date: null,
      time: null,
    },
    modalDate: false,
    modalTime: false,
  }),
  methods: {
    addFileData(e) {
      for (let file of e.target.files) {
        this.filesData.push(file);
        this.filesInfo.push({
          message: "",
          uploaded: false,
          status: false,
          progress: false,
          upload: 0,
        });
      }
      document.getElementById("fileinput").value = "";
    },
    async deleteFileData(file) {
      const id = this.filesData.indexOf(file);
      if (id < 0) return;
      this.filesData.splice(id, 1);
      this.filesInfo.splice(id, 1);
    },
    async addFiles() {
      if (this.filesData.some((f) => f.size > 524288000)) {
        this.showErrors("Nie można wysyłać plików większych niż 500 MB");
        return;
      }
      if (!this.$refs.fileForm.validate()) {
        this.showErrors("Uzupełnij wymagane pola");
        return;
      }
      if (this.filesData.length < 1) {
        this.showErrors("Brak plików");
        return;
      }
      this.progress = true;
      let response = null;
      if (!this.incomplete) {
        response = await this.createChange();
        if (!response.status) {
          this.progress = false;
          return this.showErrors(
            `Błąd przy tworzeniu zmiany: ${response.message}`
          );
        }
        this.changeData.id = response.change.id;
      }
      await this.sendFiles();
      if (!this.filesInfo.every((v) => v.status)) {
        this.incomplete = true;
        this.progress = false;
        return this.showErrors(`Błąd podczas wysyłania plików`);
      } else {
        response = await this.confirmChange();
      }

      this.progress = false;
      if (!response) return this.showErrors(`Błąd podczas wysyłania plików`);
      this.$emit("added", response.status);
      if (response.status) {
        this.showSuccess("Pliki dodane");
        return;
      }
      this.showErrors(response.message);
    },
    async createChange() {
      if (this.changeData.id > 0) return;
      return this.Api.send("post", `/filetreechanges`, {
        changeData: this.changeData,
        incognitoData: this.incognitoData,
      });
    },
    async sendFiles() {
      for (let id in this.filesData) {
        const file = this.filesData[id];
        const fileInfo = this.filesInfo[id];
        if (fileInfo.status) continue;
        fileInfo.uploaded = false;
        const data = new FormData();
        data.append("file", file);
        data.append("parentId", this.changeData.parentId);
        data.append("changeId", this.changeData.id);
        data.append("incognitoData", this.incognitoData);

        fileInfo.progress = true;
        let response = await this.Api.sendFile("post", "/files", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            fileInfo.upload = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          },
        });
        fileInfo.progress = false;
        fileInfo.uploaded = true;
        fileInfo.status = response.status;
        if (!response.status) {
          fileInfo.message = response.message;
        }
      }
    },
    async confirmChange() {
      return this.Api.send(
        "put",
        `/filetreechanges/confirm/${this.changeData.id}`,
        {
          changeData: {
            confirmed: true,
            parentId: this.changeData.parentId,
            incognitoData: this.incognitoData,
          },
        }
      );
    },
    async rejectChange() {
      if (!this.incomplete) {
        this.$emit("closed");
        return;
      }
      this.progress = true;
      const response = await this.Api.send(
        "put",
        `/filetreechanges/reject/${this.changeData.id}`,
        { changeData: { confirmed: false } }
      );
      this.progress = false;
      this.$emit("closed");
      if (response.status) {
        this.showSuccess("Zmiany odwrócone");
        return;
      }
      this.showErrors(response.message);
    },
    async showErrors(message) {
      this.snackMessage = message;
      this.snackbarColor = "error";
      this.snackbar = true;
    },
    async showSuccess(message) {
      this.snackMessage = message;
      this.snackbarColor = "success";
      this.snackbar = true;
    },
  },
  watch: {
    addFileDialog(s) {
      if (!s) return;
      this.changeData = { text: "", parentId: this.id, id: 0 };
      this.filesData = [];
      this.filesInfo = [];
      this.incomplete = false;
      this.incognitoData = {
        active: false,
        date: null,
        time: null,
      };
      this.modalDate = this.modalTime = false;
    },
  },
};
</script>

<style scoped>
.file {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>
